import { BigNumber, FixedNumber } from "ethers"

export interface DeserializedBarData {
  allowance: BigNumber
  stakedBalance: BigNumber
  totalSupply: BigNumber
}

export interface SerializedBarData {
  allowance: SerializedBigNumber
  stakedBalance: SerializedBigNumber
  totalSupply: SerializedBigNumber
}

export interface DeserializedBoostData {
  allowance: BigNumber
  pendingFer: BigNumber
  stakes: DeserializedFerroBoostStake[]
}

export interface SerializedBoostData {
  allowance: SerializedBigNumber
  pendingFer: SerializedBigNumber
  stakes: SerializedFerroBoostStake[]
}

export interface DeserializedFerroBoostStake {
  amount: BigNumber
  poolId: number
  weightedAmount: BigNumber
  stakeTimestamp: number
  unlockTimestamp: number
  active: boolean
}

export interface SerializedFerroBoostStake {
  amount: SerializedBigNumber
  poolId: number
  weightedAmount: SerializedBigNumber
  stakeTimestamp: number
  unlockTimestamp: number
  active: boolean
}

export interface SerializedBoostPoolData {
  poolWeight: SerializedBigNumber
  totalSupply: SerializedBigNumber
  poolInfo: Array<{ poolId: number; stakes: SerializedBigNumber }>
}

export interface DeserializedBoostPoolData {
  poolWeight: FixedNumber
  totalSupply: BigNumber
  poolInfo: Array<{ poolId: number; stakes: BigNumber }>
}

type SerializedBigNumber = string

export interface BarHistoryResponse {
  barDailySnapshots: BarHistoryData[]
}

export interface BarHistoryData {
  date: string
  ratio: string
}

export enum HarvestMode {
  Vault,
  Pool,
}
